export default __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-471f989f877e14c580e2f72b551a5221.svg";